(function () {
    'use strict';

    angular
        .module('observationEditModule')
        .controller('ObservationEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'grcObservationService', 'auditMandateService', 'historyCtxtService', 'observation', 'controlTest', 'oddCampaign', 'businessUnit', 'controls'];

    function Controller($scope, $state, $stateParams, grcObservationService, auditMandateService, historyCtxtService, observation, controlTest, campaign, businessUnit, controls) {

        $scope.controlTest = controlTest;
        $scope.observation = observation;
        $scope.campaign = campaign;
        $scope.businessUnit = businessUnit;
        $scope.controls = controls;

        // Get Recommendations
        if ($scope.observation.ItemID) {
            grcObservationService
                .getRecommendationsByObservationID(observation.ObservationID)
                .then(function (recommendations) {
                    $scope.recomsForObservation = recommendations;
                });
        }

        // Control Test
        $scope.goToControlTest = function (item) {
            if (_.isUndefined(item.ControlID)) return;
            if (_.isUndefined(item.ControlTestID)) return;

            $state.go('control.controlTests.edit', {
                ControlID: item.ControlID,
                ControlTestID: item.ControlTestID
            });
        };

        // Back to Observation List
        $scope.backToObservationList = function () {
            // Control Test
            if ($scope.controlTest) {
                $scope.goToControlTest($scope.controlTest);
            }

            // Audit Mandate
            else if ($scope.observation.GovernanceProcessID) {
                $state.go('auditMandate.observations', {AuditMandateID: $scope.observation.GovernanceProcessID});
            }

            // ODD Campaign
            else if ($scope.campaign) {
                $state.go('odd.externalPartyEdit.campaign.editObservationList', {
                    CampaignTypeCode: businessUnit.CampaignType.Value.toLowerCase(),
                    BusinessUnitCode: $scope.campaign.ODDBusinessUnitCode,
                    ODDExternalPartyID: $scope.campaign.ODDExternalPartyID,
                    ODDCampaignID: $scope.campaign.ODDCampaignID
                });
            }

            else {
                $state.go('home', { UserItemPersonID: $scope.authenticatedUser.ItemPersonID });
            }
        };

        // Campaign
        $scope.goToCampaign = function (campaign) {
            $state.go('odd.externalPartyEdit.campaign', {
                CampaignTypeCode: businessUnit.CampaignType.Value.toLowerCase(),
                BusinessUnitCode: campaign.ODDBusinessUnitCode,
                ODDExternalPartyID: campaign.ODDExternalPartyID,
                ODDCampaignID: campaign.ODDCampaignID
            });
        };

        // Go To Assessment
        $scope.goToAssesment = function () {
            $scope.clickOnBox();
        };

        // Go To Governance Process
        $scope.goToGovernanceProcess = function () {
            
            if (observation.GovernanceProcess.GovernanceProcessType.Value === 'Audit-Mandate') {
                
                if ($stateParams.ctxStateParams &&
                    $stateParams.ctxStateParams.AuditMandateID) {
                    $state.go('auditMandateEdit',
                            { AuditMandateID: $stateParams.ctxStateParams.AuditMandateID }, {});
                }
                else {
                    auditMandateService
                        .getAuditMandateByGovernanceProcessID(observation.GovernanceProcess.GovernanceProcessID)
                        .then(function (auditMandate) {
                            $state.go('auditMandateEdit', { AuditMandateID: auditMandate.AuditMandateID }, {});
                    });  
                }
            }
            else {
                // if not audit Mandate, Go to Governance Process 
            }

        };

        // Control
        $scope.goToControl = function (control) {
            historyCtxtService.goToState('control',
                { ControlID: control.ControlID },
                'observation'); //maybe missing auditMandate
        };

        // Add a new related control
        $scope.addControl = function (control) {
            grcObservationService
                .addControlToObservation($scope.observation.ObservationID, control.ControlID)
                                    .then(function (controls) {
                                        $scope.controls = controls;
                                    });
        };

        // Unlink a control
        $scope.unlinkControl = function (control) {
            grcObservationService
                .removeControlFromObservation($scope.observation.ObservationID, control.ControlID)
                                    .then(function () {
                                        $scope.controls = _.reject($scope.controls, { ControlID: control.ControlID });
                                    });
        };

        // Edit Recommendation
        $scope.editRecommendation = function (item) {
            historyCtxtService.goToStateWithOptions('recommendation.edit', {
                toStateParams: { RecommendationID: item.RecommendationID },
                /* 12042021 OD - Commenting below the following code so the breadcrumb
                    on the recommendation page get its state only from a single point: the routing url state 
                */
                // ctxStateName: 'observation.edit',
                // ctxItem: $scope.observation,
                // ctxtBreadcrumbTitle: 'Observation',
                // ctxtBreadcrumbIcon: 'fa fa-area-chart'
            });
        };

        // Add Recommendation
        $scope.addRecommendation = function () {
            $state.go('observation.edit.recommendationAdd');
        };
    }
})();